import { Font } from '@react-pdf/renderer';

let registered = false;

// jsdelivr mirrors @fontsource packages. @react-pdf/renderer's fontkit accepts .woff (not .woff2).
const FRAUNCES_REGULAR = 'https://cdn.jsdelivr.net/npm/@fontsource/fraunces@latest/files/fraunces-latin-400-normal.woff';
const FRAUNCES_MEDIUM = 'https://cdn.jsdelivr.net/npm/@fontsource/fraunces@latest/files/fraunces-latin-500-normal.woff';
const FRAUNCES_SEMIBOLD = 'https://cdn.jsdelivr.net/npm/@fontsource/fraunces@latest/files/fraunces-latin-600-normal.woff';

const GEIST_LIGHT = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-sans@latest/files/geist-sans-latin-300-normal.woff';
const GEIST_REGULAR = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-sans@latest/files/geist-sans-latin-400-normal.woff';
const GEIST_MEDIUM = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-sans@latest/files/geist-sans-latin-500-normal.woff';
const GEIST_SEMIBOLD = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-sans@latest/files/geist-sans-latin-600-normal.woff';
const GEIST_BOLD = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-sans@latest/files/geist-sans-latin-700-normal.woff';

const GEIST_MONO_REGULAR = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-mono@latest/files/geist-mono-latin-400-normal.woff';
const GEIST_MONO_MEDIUM = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-mono@latest/files/geist-mono-latin-500-normal.woff';
const GEIST_MONO_SEMIBOLD = 'https://cdn.jsdelivr.net/npm/@fontsource/geist-mono@latest/files/geist-mono-latin-600-normal.woff';

// Inter fallbacks — known-working gstatic TTFs. Keeps text rendering even if jsdelivr is unreachable.
const INTER_REGULAR = 'https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfMZg.ttf';
const INTER_MEDIUM = 'https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuI6fMZg.ttf';
const INTER_BOLD = 'https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuFuYMZg.ttf';

export const registerPdfFonts = (): void => {
    if (registered) return;
    registered = true;
    try {
        Font.register({
            family: 'Fraunces',
            fonts: [
                { src: FRAUNCES_REGULAR, fontWeight: 400 },
                { src: FRAUNCES_MEDIUM, fontWeight: 500 },
                { src: FRAUNCES_SEMIBOLD, fontWeight: 600 },
            ],
        });
        Font.register({
            family: 'Geist',
            fonts: [
                { src: GEIST_LIGHT, fontWeight: 300 },
                { src: GEIST_REGULAR, fontWeight: 400 },
                { src: GEIST_MEDIUM, fontWeight: 500 },
                { src: GEIST_SEMIBOLD, fontWeight: 600 },
                { src: GEIST_BOLD, fontWeight: 700 },
            ],
        });
        // Explicit family aliases kept so legacy references to `Geist-Medium` / `Geist-Bold` still resolve.
        Font.register({ family: 'Geist-Medium', src: GEIST_MEDIUM });
        Font.register({ family: 'Geist-Bold', src: GEIST_BOLD });

        Font.register({
            family: 'GeistMono',
            fonts: [
                { src: GEIST_MONO_REGULAR, fontWeight: 400 },
                { src: GEIST_MONO_MEDIUM, fontWeight: 500 },
                { src: GEIST_MONO_SEMIBOLD, fontWeight: 600 },
            ],
        });

        // Fallback stack in case the primary CDN TTFs fail to resolve during PDF rendering.
        Font.register({
            family: 'Inter',
            fonts: [
                { src: INTER_REGULAR, fontWeight: 400 },
                { src: INTER_MEDIUM, fontWeight: 500 },
                { src: INTER_BOLD, fontWeight: 700 },
            ],
        });
        Font.register({ family: 'Inter-Medium', src: INTER_MEDIUM });
        Font.register({ family: 'Inter-Bold', src: INTER_BOLD });

        Font.registerHyphenationCallback((word) => [word]);
    } catch {
        // silent — react-pdf will fall back to Helvetica if registration fails mid-run
    }
};

registerPdfFonts();
